import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { vsmNotify } from "../../../../config/messages/common";

export default class ManageClientPaymentsStore {
	detail_filter = null;
	agGridDetail = null;
	per_page_overview = ServerGridConfig.options.paginationPageSize;
	current_page_detail = 1;
	list_data_detail = null;
	total_detail = 0;
	allColumnIdsDetail = [];
	//This is for summary
	summary_filter = null;
	agGridSummary = null;
	agGridOverview = null;
	agGridCancelled = null
	per_page_summary = ServerGridConfig.options.paginationPageSize;
	per_page_cancelled = ServerGridConfig.options.paginationPageSize;
	current_page_summary = 1;
	list_data_summary = null;
	list_data = null;
	total_summary = 0;
	allColumnIdsSummary = [];
	overview_filter = null;
	cancelled_filter = null;
	deleteValues = null;
	sendemailValues = null;
	viewValues = null;
	daliyBookingValues = null;
	selectAll = false;
	selectCount = 0;
	paymentSummaryValues = null
	outsandingviewValues = null
	fromDayOne = false
	overview_data_summary= null
	isSelectAllOverview = false;
	selectCountOverview = 0;
	visibleRowCountOverview = 0;
	selectedRowCountOverview = 0;
	selectAllOverviewArr = []
	isCardBoxCount = 1
	pinnedBottomSummary = []

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data;
	};

	// set form values to Send Email
	setSendEmailValues = (data) => {
		this.sendemailValues = data;
	};

	// set form values to view
	setViewValues = (data) => {
		this.viewValues = data;
	};

	// set form values to view
	setOutsandingViewValues = (data) => {
		this.outsandingviewValues = data;
	};

	// set form values to view
	setDaliyBookingValues = (data) => {
		this.daliyBookingValues = data;
	};

	// set form values to view
	setPaymentSummaryValues = (data) => {
		this.paymentSummaryValues = data;
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGridSummary.api.paginationSetPageSize(parseInt(page));
		}
	};

	setFromDayOne = (data) => {
		this.fromDayOne = data
	}

	setIsSelectAllOverview = (data) => {
		this.isSelectAllOverview = data
	}

	setSelectedRowCountOverview = (data) => {
		this.selectedRowCountOverview = data;
	}

	setVisibleRowCountOverview = (data) => {
		this.visibleRowCountOverview = data;
	}

	setSelectAllOverviewArr = (data) => {
		this.selectAllOverviewArr = data
	}

	setIsCardBoxCount = (data) => {
		this.isCardBoxCount = data
	}

	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var payload = {
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					is_estimation: this.overview_filter ? this.generatePayload(this.overview_filter.is_estimation) : this.summary_filter ? this.generatePayload(this.summary_filter.is_estimation) : this.generatePayload(this.cancelled_filter),
					from_date: this.overview_filter ? this.generatePayload(this.overview_filter.from_date) : this.summary_filter ? this.generatePayload(this.summary_filter.from_date) : this.generatePayload(this.cancelled_filter),
					to_date: this.overview_filter ? this.generatePayload(this.overview_filter.to_date) : this.summary_filter ? this.generatePayload(this.summary_filter.to_date) : this.generatePayload(this.cancelled_filter),
					client_id: this.overview_filter ? this.generatePayload(this.overview_filter?.client_id) : this.summary_filter ? this.generatePayload(this.summary_filter?.client_id) : this.generatePayload(this.cancelled_filter?.client_id),
					client_name: this.overview_filter ? this.generatePayload(this.overview_filter?.client_name) : this.summary_filter ? this.generatePayload(this.summary_filter?.client_name) : this.generatePayload(this.cancelled_filter?.client_name),
					invoice_no: this.overview_filter ? this.generatePayload(this.overview_filter?.invoice_no) : this.summary_filter ? this.generatePayload(this.summary_filter?.invoice_no) : this.generatePayload(this.cancelled_filter?.invoice_no),
					from_day_one : this.overview_filter ? this.generatePayload(this.overview_filter?.from_day_one) : this.summary_filter ? this.generatePayload(this.summary_filter?.from_day_one) : this.generatePayload(this.cancelled_filter?.from_day_one),
					page: Math.ceil(
						(params.request.startRow + 1) /
						(params.request.endRow - params.request.startRow)
					),
				};
				if (this.isCardBoxCount === 3) {
					if (this.summary_filter) {
						this.getHistoryList(payload).then((data) => {
							if (data?.list?.total === 0) {
								this.agGridSummary.api.showNoRowsOverlay();
							} else {
								this.agGridSummary.api.hideOverlay();
							}
							params.successCallback(data?.list ? data?.list?.data : [], data?.list ? data?.list?.total : 0);
							var allColumnIds = [];
							if (this.agGridSummary && this.agGridSummary.columnApi && data?.total) {
								this.agGridSummary.columnApi.getAllColumns().forEach(function (column) {
									allColumnIds.push(column.col_id);
								});
							}
						})
					}
					else {
						this?.agGridSummary?.api.showNoRowsOverlay();
						params.successCallback([], 0)
						var allColumnIds = []
						if (this.agGridSummary && this.agGridSummary.columnApi && 0) {
							this.agGridSummary.columnApi.getAllColumns().forEach(function (column) {
								allColumnIds.push(column.col_id)
							})
						}
					}
				}
				if (this.isCardBoxCount === 4) {
					if (this.overview_filter) {
						this.getListOverview(payload).then((data) => {
							if (data.client.total === 0) {
								this.agGridOverview.api.showNoRowsOverlay();
							} else {
								this.agGridOverview.api.hideOverlay();
							}
							params.successCallback(data.client.data, data.client.total);
							let allColumnIds = [];
							if (this.agGridOverview && this.agGridOverview.columnApi && data.total) {
								this.agGridOverview.columnApi.getAllColumns().forEach(function (column) {
									allColumnIds.push(column.col_id);
								});
							}
						})
					}
					else {
						this?.agGridOverview?.api.showNoRowsOverlay();
						params.successCallback([], 0)
						let allColumnIds = []
						if (this.agGridOverview && this.agGridOverview.columnApi && 0) {
							this.agGridOverview.columnApi.getAllColumns().forEach(function (column) {
								allColumnIds.push(column.col_id)
							})
						}
					}
				}
				
			},
		};
	};

	// set form values to  customefilter
	setSummaryFilterValues = (data) => {
		return new Promise((resolve) => {
			this.summary_filter = data;
			if (this.agGridSummary) {
				this.setupGridSummary(this.agGridSummary);
			}
			resolve()
		});
	};

	// set form values to  customefilter
	setOverviewFilterValues = (data) => {
		return new Promise((resolve) => {
			this.overview_filter = data;
			if (this.agGridOverview) {
				this.setupGridOverview(this.agGridOverview);
			}
			resolve()
		});
	};

	// set form values to  customefilter
	setCancelledFilterValues = (data) => {
		return new Promise((resolve) => {
			this.cancelled_filter = data;
			if (this.agGridCancelled) {
				this.setupGridCancelled(this.agGridCancelled);
			}
			resolve()
		});
	};

	// Setup grid and set column size to autosize
	setupGridSummary = (params) => {
		this.pinnedBottomSummary = []
		this.agGridSummary = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};


	// Setup grid and set column size to autosize
	setupGridOverview = (params) => {
		// this.agGridOverview = params;
		this.agGridOverview = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};
	setOverviewFilter = (data) => {
		this.overview_filter = data;
	};

	// Setup grid and set column size to autosize
	setupGridCancelled = (params) => {
		// this.agGridCancelled = params;
		this.agGridCancelled = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};
	setCancelledFilter = (data) => {
		this.cancelled_filter = data;
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSizeSummary = (page = this.per_page_summary) => {
		this.per_page_summary = page;
		if (this.agGridSummary) {
			this.agGridSummary.api.paginationSetPageSize(parseInt(page));
		}
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSizeOverview = (page = this.per_page_overview) => {
		this.per_page_overview = page;
		if (this.agGridOverview) {
			this.agGridOverview.api.paginationSetPageSize(parseInt(page));
		}
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSizeCancelled = (page = this.per_page_cancelled) => {
		this.per_page_cancelled = page;
		if (this.agGridCancelled) {
			this.agGridCancelled.api.paginationSetPageSize(parseInt(page));
		}
	};

	// Filter function for no record found message
	onFilterChangedSummary = (params) => {
		this.agGridSummary = params;
		if (this.agGridSummary && this.agGridSummary.api.getModel().getRowCount() === 0) {
			this.agGridSummary.api.showNoRowsOverlay();
		}
		if (this.agGridSummary && this.agGridSummary.api.getModel().getRowCount() > 0) {
			this.agGridSummary.api.hideOverlay();
		}
	};
	// Filter function for no record found message
	onFilterChangedOverview = (params) => {
		if(this.agGridOverview) {
			this.agGridOverview.api.deselectAll();
			this.setupGridOverview(this.agGridOverview)
			this.setVisibleRowCountOverview(0)
			this.setSelectedRowCountOverview(0)
			this.setSelectAllOverviewArr([])
		}
		this.agGridOverview = params;
		if (this.agGridOverview && this.agGridOverview.api.getModel().getRowCount() === 0) {
			this.agGridOverview.api.showNoRowsOverlay();
		}
		if (this.agGridOverview && this.agGridOverview.api.getModel().getRowCount() > 0) {
			this.agGridOverview.api.hideOverlay();
		}
	};
	// Filter function for no record found message
	onFilterChangedCancelled = (params) => {
		this.agGridCancelled = params;
		if (this.agGridCancelled && this.agGridCancelled.api.getModel().getRowCount() === 0) {
			this.agGridCancelled.api.showNoRowsOverlay();
		}
		if (this.agGridCancelled && this.agGridCancelled.api.getModel().getRowCount() > 0) {
			this.agGridCancelled.api.hideOverlay();
		}
	};
	generatePayload = (summary_filter) => {
		// if (summary_filter.from_date) {
		//     summary_filter.from_date = moment(summary_filter.from_date).format('YYYY-MM-DD');
		// }
		// if (summary_filter.to_date) {
		//     summary_filter.to_date = moment(summary_filter.to_date).format('YYYY-MM-DD');
		// }
		return summary_filter;
	}

	refreshList = () => {
		if (this.agGridSummary) {
			this.setupGridSummary(this.agGridSummary);
		}
	}

	refreshOverviewList = () => {
		if (this.agGridOverview) {
			this.agGridOverview.api.deselectAll();
			this.setVisibleRowCountOverview(0)
			this.setSelectedRowCountOverview(0)
			this.setSelectAllOverviewArr([])
			this.setIsSelectAllOverview(false)
			this.setupGridOverview(this.agGridOverview);
		}
	}

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;
		return { final_filter, final_sort }
	}
	// call api to get records
	getListOverview = (payload) => {
		return Axios.post(`monthly-activities/client-invoices-payments/outstanding-by-client`, payload).then(({ data }) => {
			if (data.client.data.length) {
				let startPage = (data.client.current_page - 1) * data.client.per_page;
				data.client.data.map((item, index) => {
					item.srno = startPage + index + 1;
					this.setVisibleRowCountOverview(this.visibleRowCountOverview + 1)
					return null;
				});
			}
			if (this.visibleRowCountOverview > 0 && this.visibleRowCountOverview !== this.selectedRowCountOverview) {
				this.setIsSelectAllOverview(false)
			}
			this.list_data_summary = data.client ? data.client.data : null;
			this.total_summary = data.client.total;
			this.current_page_summary = data.client.current_page;
			return data;
		});
	};

	// call api to get records
	getHistoryList = (payload) => {
		return Axios.post(`monthly-activities/client-invoices-payments/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					return null;
				});
			}
			this.pinnedBottomSummary = (data.list.data.length > 0) ? [data.footer_total] : []
			this.list_data_summary = data.list ? data.list.data : null;
			this.total_summary = data.list.total;
			this.current_page_summary = data.list.current_page;
			return data;
		}).catch((e) => {
			if (e.errors && e.errors.length > 0) {
				let errorMessage = e.errors[0].errors.join(", ");
				vsmNotify.error({
					message: errorMessage,
				});
			}})
	};

	AddPaymentData = (formdata) => {
		return Axios.post(`monthly-activities/client-invoices-payments/generate`, formdata)
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// call api to get records
	getListCancelled = (payload) => {
		return Axios.post(`monthly-activities/client-invoices/cancel-list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					return null;
				});
			}
			this.list_data_summary = data.list ? data.list.data : null;
			this.total_summary = data.list.total;
			this.current_page_summary = data.list.current_page;
			return data;
		});
	};

	doGenerateBills = (data) => {
		return Axios.post(`/monthly-activities/client-invoices/generate`, data)
			.then(({ data }) => {
				this.agGridOverview.api.deselectAll();
				if (this.agGridOverview) {
					this.setupGridOverview(this.agGridOverview);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};
	doGenerateBillsPdf = (data) => {
		return Axios.post(`/monthly-activities/client-invoices/print`, data)
			.then(({ data }) => {
				this.agGridSummary.api.deselectAll();
				if (this.agGridSummary) {
					this.setupGridSummary(this.agGridSummary);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// call api to get records
	ViewData = (formData) => {
		return Axios.post(`monthly-activities/client-invoices-payments/detail`, formData).then(({ data }) => {
			this.setViewValues(data.detail)
			return data;
		}).catch(({ response: { data } }) => {
			var errors = [];
			var notify = null;
			const { NOTIFICATION, ...fieldErrors } = data.STATUS;
			if (data && data.STATUS) {
				if (NOTIFICATION) {
					notify = NOTIFICATION[0];
				}
				Object.keys(fieldErrors).forEach((name) => {
					errors.push({ name, errors: data.STATUS[name] });
				});
			}
			return Promise.reject({ errors, notify });
		});

	};

	ViewOutstandingData = (formData) => {
		return Axios.post(`monthly-activities/client-invoices-payments/outstanding-by-client/detail`, formData).then(({ data }) => {
			this.setOutsandingViewValues(data)
			return data;
		});
	};

	//Get List of center for dropdown
	getPaymentSummary = (conditional = {}) => {
		return Axios.post(`monthly-activities/client-invoices-payments/get-summary`, conditional)
			.then(({ data }) => {
				this.setPaymentSummaryValues(data)
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	// Call delete api
	DeleteData = (formdata) => {
		return Axios.get(`/monthly-activities/client-invoices-payments/cancellation/${formdata.id}`)
			.then(({ data }) => {
				if (this.agGridSummary) {
					this.setupGridSummary(this.agGridSummary);
				}
				return data;
			})
	};

	doExportDownloadDetail = (formData) => {
		return Axios.post(`/monthly-activities/client-invoices-payments/print`, formData)
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	onFirstDataRendered = () => {
		if (this.selectAll === true) {
			this.agGridCancelled.api.forEachNode((node) => {
				this.selectCount++;
				return node.setSelected(!!node.data);
			});
		}
	};

	
	onSelectAllRender = (selectAllFlag) => {
		if (selectAllFlag === true) {
			this.onFirstDataRendered()
		} else {
			this.agGridCancelled.api.forEachNode((node) => {
				return node.setSelected(false);
			});
		}
	}
	
	onFirstDataOverviewRendered = () => {
		if (this.isSelectAllOverview === true && this.agGridOverview) {
			this.agGridOverview.api.forEachNode((node) => {
				this.selectCountOverview++;
				this.setSelectedRowCountOverview(this.selectedRowCountOverview + 1)
				node.setSelected(true);
			});
		}
	};

	onSelectAllOverviewRender = (selectAllFlag) => {
		if (selectAllFlag === true) {
			this.onFirstDataOverviewRendered();
		} else {
			this.agGridOverview.api.forEachNode((node) => {
				this.setSelectedRowCountOverview(0);
				node.setSelected(false);
			});
		}
	};

	doExportDownloadOutStanding = (data) => {
		return Axios.post(`monthly-activities/client-invoices-payments/outstanding-by-client`, data)
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	PrintOutstandingData = (formData) => {
		return Axios.post(`monthly-activities/client-invoices-payments/outstanding-by-client/print`, formData).then(({ data }) => {
				this.agGridOverview.api.deselectAll();
				this.setSelectedRowCountOverview(0)
				this.setSelectAllOverviewArr([])
				this.setIsSelectAllOverview(false)
			return data
		})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	}

	sendEmailOutstandingData = (formdata) => {
		return Axios.post(`/monthly-activities/client-invoices-payments/outstanding-by-client/send-email` ,formdata)
			.then(({ data }) => {
					this.agGridOverview.api.deselectAll();
					this.setSelectedRowCountOverview(0)
					this.setSelectAllOverviewArr([])
					this.setIsSelectAllOverview(false)
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	doExportDownloadPaymentHistory = (data) => {
		return Axios.post(`monthly-activities/client-invoices-payments/list`, data)
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};
}

decorate(ManageClientPaymentsStore, {
	setSummaryFilterValues: action,
	setOverviewFilterValues: action,
	onFilterChangedOverview: action,
	per_page_summary: observable,
	per_page_overview: observable,
	per_page_cancelled: observable,
	agGridSummary: observable,
	list_data_summary: observable,
	list_data: observable,
	total_summary: observable,
	allColumnIdsSummary: observable,
	setupGridSummary: action,
	setupGridOverview: action,
	setPageSizeSummary: action,
	getListOverview: action,
	getHistoryList: action,
	onFilterChangedSummary: action,
	summary_filter: observable,
	agGridOverview: observable,
	setOverviewFilter: action,
	overview_filter: observable,
	setDeleteValues: action,
	deleteValues: observable,
	setSendEmailValues: action,
	sendemailValues: observable,
	ViewData: action,
	setViewValues: action,
	viewValues: observable,
	setDaliyBookingValues: action,
	daliyBookingValues: observable,
	setCancelledFilterValues: action,
	onFilterChangedCancelled: action,
	setupGridCancelled: action,
	getListCancelled: action,
	agGridCancelled: observable,
	setCancelledFilter: action,
	cancelled_filter: observable,
	selectAll: observable,
	setCheckState: action,
	onFirstDataRendered: action,
	onSelectAllRender: action,
	selectCount: observable,
	setIsEstimation: action,
	isEstimation: observable,
	getPaymentSummary: action,
	setPaymentSummaryValues: action,
	paymentSummaryValues: observable,
	setOutsandingViewValues: action,
	outsandingviewValues: observable,
	fromDayOne : observable,
	setFromDayOne : action,
	doExportDownloadOutStanding: action,
	overview_data_summary : observable,
	PrintOutstandingData: action,
	sendEmailOutstandingData: action,
	refreshOverviewList : action,
	isSelectAllOverview: observable,
	selectCountOverview:observable,
	visibleRowCountOverview : observable,
	selectedRowCountOverview : observable,
	selectAllOverviewArr : observable,
	setIsSelectAllOverview : action,
	setSelectedRowCountOverview : action,
	onFirstDataOverviewRendered : action,
	onSelectAllOverviewRender : action,
	setVisibleRowCountOverview : action,
	setSelectAllOverviewArr: action,
	isCardBoxCount: observable,
	setIsCardBoxCount: action,
	doExportDownloadPaymentHistory: action,
	pinnedBottomSummary : observable,
});